import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export default class FocusTrap extends Vue {
  firstFocusableEl: any;
  lastFocusableEl: any;
  modalMaskClass: string = '.modal-mask';
  // TODO: redo this component to become infinite. The parent compoment lifecycle is responsible for allocating and dealocating this resource
  watcherStart = 25;
  watcherTreshold = 1000;

  setModalMask(modalMaskClass: string) {
    this.modalMaskClass = modalMaskClass;
    this.trapFocus();
  }

  getModalMask(): string {
    return this.modalMaskClass;
  }

  trapFocus(reset = false) {
    if (reset){
      this.firstFocusableEl = undefined;
      this.watcherStart = 25;
    }
    // The purpose of this function is to trap focus inside the modal.
    const querySelector = `${this.modalMaskClass} button, ${this.modalMaskClass} [href], ${this.modalMaskClass} input, ${this.modalMaskClass} select, ${this.modalMaskClass} textarea, ${this.modalMaskClass} [tabindex]:not([tabindex="-1"])`;
    // It query selects all possible focusable elements inside the modal
    const focusable = document.querySelectorAll(querySelector);
    const focusableFiltered = [...Array.from(focusable)].filter(
      el => this.isElementSeen(el as HTMLElement)
    );

    if (focusableFiltered.length === 0) {
      this.watchFirstFocus(); 
      return;
    }
    // The first element will help keep this trap circular
    this.firstFocusableEl = focusableFiltered[0] as HTMLElement;
    this.watchFirstFocus();

    // By default, the first focusable element will receive focus
    this.firstFocusableEl.focus();

    if (focusable.length === 1) 
      // Focus is trapped on one element only
      this.firstFocusableEl.addEventListener(
        'keydown',
        this.trapListenerHandlerFirstElementOnly
      );
    else {
      // Together with first element it'll keep focus circular inside modal
      this.lastFocusableEl = focusable[focusable.length - 1] as HTMLElement;
      // Adds the trapHandler to both first and last elements
      // It overrides default focus behaviour
      const trplHandler = this.trapLisetnerHandler;
      this.firstFocusableEl.addEventListener('keydown', trplHandler);
      this.lastFocusableEl.addEventListener('keydown', trplHandler);
    }
  }

  watchFirstFocus() {
    // helper to conform with our video
    // the main problem is: play button disappears and we don't know when
    let functionToCall = () => {};
    // so we watch the firstFocusableElement
    if (this.firstFocusableEl) {
      // the first element exists, so we watch it
      const firstElDisplay = window.getComputedStyle(this.firstFocusableEl).display;
      if (!this.isElementSeen(this.firstFocusableEl)) 
        // if it turned to none suddenly, we trap focus again
        functionToCall = this.trapFocus;
      else if(firstElDisplay === 'block') 
        // if it stays in block we just call that function: keep watching
        functionToCall = this.watchFirstFocus;
      
      // in case the element does not have a display, we could have lost it (modal is gone)
      // So we call no function (kind of a recursion stopping point)
    } else 
      // if the first element doesnt exist, we call focus trap again. 
      // We were too fast trying to fetch it
      functionToCall = this.trapFocus;
    
    // this ensembles recursion: 
    // watcher will be called in every x milliseconds. So it'll be called around 1000/x times in the course of a second
    // Even in slow environments, it seems to be enoug
    if (this.watcherStart < this.watcherTreshold) {
      setTimeout(() => {
        functionToCall(); // the function decided to be called: trapFocus or watchFirstFocus
      }, this.watcherStart);
      this.watcherStart += 50;
    }
  }

  trapListenerHandlerFirstElementOnly(e: any) {
    this.trapFocusElementHandler(
      e,
      this.firstFocusableEl,
      this.firstFocusableEl
    );
  }

  trapLisetnerHandler(e: any) {
    this.trapFocusElementHandler(
      e,
      this.firstFocusableEl,
      this.lastFocusableEl
    );
  }

  trapFocusElementHandler(e: any, firstFocusableEl: any, lastFocusableEl: any) {
    const KEYCODE_TAB: number = 9;
    //Handling the trap focus process
    // User must have clicked tab button, with shift or not pressed
    const isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;
    if (!isTabPressed) return;
    // If shift key was pressed
    if (e.shiftKey) {
      // In case focus is with first element and shift+tab is pressed
      // Tab order is changed and the LAST modal element will receive focus
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus();
        this.preventDefault(e);
      }
    } else 
    //In case focus is with last element and tab is pressed
    //Tab order is changed and the FIRST modal element will receive focus
    if (document.activeElement === lastFocusableEl) {
      firstFocusableEl.focus();
      this.preventDefault(e);
    }
    
  }

  preventDefault(e: any) {
    if (e.preventDefault && typeof e.preventDefault === 'function')
      e.preventDefault();
  }

  isElementSeen(el: HTMLElement){
    return (window.getComputedStyle(el).display !== 'none' && (el as HTMLElement).offsetWidth > 0 && (el as HTMLElement).offsetHeight > 0);
  }
}
